//配置自定义验证规则
export const validaterules = {
  mobile: {
    getMessage: (field, [args]) => '手机号码输入不正确',
    validate(value) {//字段校验规则
      return value.length == 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/.test(value)
    }
  },
  cellPhone: {
    getMessage: (field, [args]) => '请输入正确的用户名或手机号',
    validate(value) {//字段校验规则
      var reg = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      //18位
      var regs = /^\w{6,20}$/;
      return reg.test(value) || regs.test(value);
    }
  },
  usercode: {
    getMessage: (field, [args]) => '用户名由6-20位英文、数字和下划线组成',
    validate(value) {
      // 长度为6-20为的单词字符组成
      let reg = /^\w{6,20}$/;
      return reg.test(value);
    }
  },
  verificationCode: {
    getMessage: (field, [args]) => '验证码由4到6位的数字组成',
    validate(value) {
      // 获得验证码
      let reg = /^[0-9]{4}$/;
      return reg.test(value);
    }
  },
  idCard: {
    getMessage: (field, [args]) => '身份证号码输入不正确',
    validate: value => {
      var reg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      //18位
      var regs =
        /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      return reg.test(value) || regs.test(value);
    }
  },
  passWord: {
    getMessage: (field, [args]) => '密码长度必须为6-20位',
    validate: value => {
      // let reg1 = /\d+/;
      // let reg2 = /[a-zA-Z]/;
      var reg1 = /^.{6,20}$/;
      return reg1.test(value);
    }
  },
  secretCode: {
    getMessage: (field, [args]) => '密码需为6-20位数字与字母组合',
    validate: value => {
      let reg1 = /\d+/;
      let reg2 = /[a-zA-Z]/;
      return value.length >= 6 && value.length <= 20 &&reg1.test(value) && reg2.test(value);
    }
  },
  twoPassword: {
    getMessage: (field, [args]) => '您两次输入的密码不一样',
    validate: value => {

    }
  },
  email: {
    getMessage: (field, [args]) => '邮箱格式不正确',
    validate: value => {
      let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      return reg.test(value)
    }
  }
}
// 自定义校验为空的信息
export const dictionary = {
  zh_CN: {
    messages: {
      required: ((field) => {
        if (field === '性别' || field === '所在医院' || field === '学位' || field === '职称') {
          return '请选择' + field
        } else {
          return '请输入' + field
        }
      })
    },
    attributes: {
      // 保存field 与所在标签的name 对应，即可匹配到下面的中文属性
      username: '用户名',
      cellPhone: '用户名或手机号',
      verificationCode: '验证码',
      password: '密码',
      secretCode: '密码',
      twoPassword: '再次确认密码',
      idCard: '身份证',
      mobile: '手机号码',
      email: '邮箱',
      name: '姓名',
      sex: '性别',
      hospital: '所在医院',
      degree: '学位',
      title: '职称',
      eCertificate: '执业证书',
      eSignature: '电子签名'
    }
  }
}
// 自定义的配置
export const config = {
  errorBagName: 'error',
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'zh_CN',
  strict: true, // 没有设置规则的表单不进行校验，
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur', // 在用户输入和表单失去焦点时都进行校验 可单独写  blur或input
  inject: true
}




//////////////////
// WEBPACK FOOTER
// ./static/js/customvalidator.js
// module id = null
// module chunks = 